import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"
import "./style.scss"

function Trend({ children, data }) {
  if (data && data.length >= 1) {
    return <div className="trend">
      {children}
    </div>
  } else {
    return null
  }
}

Trend.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    date: DATE.isRequired,
    value: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
  })).isRequired,
  children: PropTypes.element.isRequired,
}

export default Trend
